import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface AssistantContextType {
  contextType: 'general' | 'project' | 'orchestration';
  contextId?: number;
  projectId?: number;
}

interface AssistantContextProviderProps {
  children: ReactNode;
}

interface AssistantContextState {
  context: AssistantContextType;
  setContext: (context: AssistantContextType) => void;
}

const AssistantContext = createContext<AssistantContextState | undefined>(undefined);

export const AssistantContextProvider: React.FC<AssistantContextProviderProps> = ({ children }) => {
  const [context, setContext] = useState<AssistantContextType>({
    contextType: 'general'
  });

  return (
    <AssistantContext.Provider value={{ context, setContext }}>
      {children}
    </AssistantContext.Provider>
  );
};

export const useAssistantContext = () => {
  const context = useContext(AssistantContext);
  if (context === undefined) {
    throw new Error('useAssistantContext must be used within an AssistantContextProvider');
  }
  return context;
};